export default __webpack_public_path__ + "static/media/AlphaDiag.02fae65c.png";